import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Banner from './components/banner/Banner';
import Brochure from './components/brochure/Brochure';
import TopQuality from './components/topQuality/topQuality';
import Industries from './components/industries/industries';
import AboutUs from './components/aboutUs/AboutUs';
import Products from './components/products/Products';
import RequestQuote from './components/requestQuote/RequestQuote';
import Contact from './components/contact/Contact';
import ContactForm from './components/contactForm/ContactForm';
import './i18n';
import ProductsSlider from './components/productsSlider/productsSlider';
import ChooseUs from './components/chooseUs/chooseUs';
import Statistics from './components/statistics/statistics';
import Footer from './components/footer/Footer';
import ApplicationsSlider from './components/applicationsSlider/ApplicationsSlider';
import Applications from './components/applications/Applications';
import { Stack } from '@mui/material';
// import { createTheme } from '@mui/material/styles';

function App() {
  // const theme = createTheme({
  //   typography: {
  //     fontFamily: 'Rubik, Arial, sans-serif',
  //     h1: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     h2: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     h3: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     h4: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     h5: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     h6: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     body1: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     body2: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //     button: {
  //       fontFamily: 'Rubik, Arial, sans-serif',
  //     },
  //   },
  //   components: {
  //     MuiCssBaseline: {
  //       styleOverrides: {
  //         '@font-face': {
  //           fontFamily: 'Rubik',
  //           src: 'url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap")',
  //         },
  //       },
  //     },
  //   },
  // });

  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Stack spacing={10}>
                  <Banner />
                  <Brochure />
                  <ProductsSlider />
                  <ApplicationsSlider />
                  <ChooseUs />
                  <Statistics />
                </Stack>
              </>
            }
          />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/applications" element={<Applications />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
